import * as sentry from '../../src/utils/sentry'
import { DS_setData } from '../DS/DS.Data'
import { IDB_featureFlags } from '../IDB/IDB.dexie'

export async function Cust_initialise() {
    try {
        // Read feature flags from disk
        const featureFlags = await IDB_featureFlags().get()
        if (featureFlags == null) return

        // And load into data store
        DS_setData('FeatureFlagsLoaded', () => ({ featureFlags }))
    } catch (error) {
        sentry.simpleError(error)
    }
}
